import React from "react";
import {
  Box,
  Heading,
  Text,
  VStack,
  List,
  ListItem,
  ListIcon,
} from "@chakra-ui/react";
import { FaCheckCircle, FaTools } from "react-icons/fa";

const UnclogSinkPage = () => {
  return (
    <Box minH="100vh" bg="white">
      {/* Hero Section */}
      <Box
        bg="white"
        py={{ base: 16, md: 20 }}
        px={{ base: 6, md: 12 }}
        textAlign="center"
      >
        <Heading
          as="h1"
          fontSize={{ base: "4xl", md: "5xl" }}
          fontWeight="800"
          color="gray.900"
          mb={6}
          fontFamily="'Work Sans', sans-serif"
        >
          How to Unclog a Sink with Household Items
        </Heading>
        <Text
          fontSize={{ base: "lg", md: "xl" }}
          color="gray.600"
          maxW="2xl"
          mx="auto"
        >
          A clogged sink can be a real nuisance, but you can tackle it with
          simple household items. Follow this step-by-step guide to unclog your
          sink without calling a plumber!
        </Text>
      </Box>

      {/* Content Section */}
      <Box bg="gray.50" py={{ base: 12, md: 16 }} px={{ base: 6, md: 12 }}>
        <Box maxW="1000px" mx="auto">
          {/* Tools & Materials Section */}
          <Box
            mb={12}
            p={8}
            bg="white"
            border="1px solid"
            borderColor="gray.200"
            borderRadius="xl"
            boxShadow="sm"
          >
            <Heading
              as="h2"
              fontSize="2xl"
              mb={4}
              color="gray.900"
              fontWeight="700"
            >
              Tools & Materials You'll Need
            </Heading>
            <List spacing={3}>
              <ListItem color="gray.700">
                <ListIcon as={FaTools} color="orange.500" />
                Baking Soda
              </ListItem>
              <ListItem color="gray.700">
                <ListIcon as={FaTools} color="orange.500" />
                Vinegar
              </ListItem>
              <ListItem color="gray.700">
                <ListIcon as={FaTools} color="orange.500" />
                Boiling Water
              </ListItem>
              <ListItem color="gray.700">
                <ListIcon as={FaTools} color="orange.500" />
                Plunger (optional)
              </ListItem>
            </List>
          </Box>

          {/* Step-by-Step Instructions */}
          <VStack align="start" spacing={8} mb={8}>
            {/* Step 1 */}
            <Box>
              <Heading
                as="h2"
                fontSize="2xl"
                color="gray.900"
                fontWeight="700"
                mb={2}
              >
                Step 1: Pour Baking Soda Down the Drain
              </Heading>
              <Text fontSize="lg" color="gray.600" mb={4}>
                Start by pouring about 1/2 cup of baking soda directly down the
                clogged drain. This will help break down the clog.
              </Text>
            </Box>

            {/* Step 2 */}
            <Box>
              <Heading
                as="h2"
                fontSize="2xl"
                color="gray.900"
                fontWeight="700"
                mb={2}
              >
                Step 2: Add Vinegar
              </Heading>
              <Text fontSize="lg" color="gray.600" mb={4}>
                Follow the baking soda with 1 cup of vinegar. This will create a
                fizzing reaction that helps to break up the clog.
              </Text>
            </Box>

            {/* Step 3 */}
            <Box>
              <Heading
                as="h2"
                fontSize="2xl"
                color="gray.900"
                fontWeight="700"
                mb={2}
              >
                Step 3: Wait and Flush with Boiling Water
              </Heading>
              <Text fontSize="lg" color="gray.600" mb={4}>
                Let the mixture sit for about 15-20 minutes. After that,
                carefully pour boiling water down the drain to flush everything
                through.
              </Text>
            </Box>

            {/* Step 4 */}
            <Box>
              <Heading
                as="h2"
                fontSize="2xl"
                color="gray.900"
                fontWeight="700"
                mb={2}
              >
                Step 4: Use a Plunger if Necessary
              </Heading>
              <Text fontSize="lg" color="gray.600" mb={4}>
                If the clog persists, try using a plunger to create suction and
                dislodge the blockage. Ensure there's enough water in the sink
                to cover the plunger's cup.
              </Text>
            </Box>
          </VStack>
        </Box>
      </Box>

      {/* Final Message Section */}
      <Box
        bg="white"
        py={{ base: 12, md: 16 }}
        px={{ base: 6, md: 12 }}
        textAlign="center"
      >
        <Text
          fontSize={{ base: "xl", md: "2xl" }}
          fontWeight="600"
          color="gray.800"
          maxW="3xl"
          mx="auto"
        >
          Congratulations! You’ve successfully unclogged your sink. If you still
          experience issues, it might be time to call a professional plumber.
        </Text>
      </Box>
    </Box>
  );
};

export default UnclogSinkPage;
